import React, { useEffect } from 'react';
import { useModal } from '../../../components/v2/Modal/useModal';
import { Dir } from '..';
import { DirPermissionsForm } from '../components/Permissions/DirPermissionsForm';
import { useDirsActions, useSingleDir } from '../hooks';
import Section from 'components/v2/Section/Section';
import Loader from 'components/v2/Loader/Loader';
import { useTranslation } from 'utils/translation';
import { refetchActiveQueries } from '../../../utils/QueryClientProvider';

const PermissionsForWithStateAdapter = ({ id }: any) => {
  const { readDir } = useDirsActions();
  const { dir: dirFromState = null, isFetching } = useSingleDir(id);

  useEffect(() => {
    readDir({ id });

    return () => {
      void refetchActiveQueries();
    };
  }, []);

  if (!dirFromState || isFetching) {
    return <Loader />;
  }

  return <DirPermissionsForm dir={dirFromState!} />;
};

const useDirectoryPermissions = (dir: Pick<Dir, 'id'>) => {
  const modal = useModal();
  const { t } = useTranslation();

  return () =>
    modal.open(
      () => (
        <Section>
          <PermissionsForWithStateAdapter id={dir.id} />
        </Section>
      ),
      { title: t('directory_modal_user_rights') },
    );
};

export default useDirectoryPermissions;
